var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoaLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "desktop/footer",
    transform: "translate(-1174.000000, -401.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1174.000000, 401.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 1.54545455,
    cx: 17,
    cy: 17,
    r: 16.2272727
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66254383,14.2283146 L12.6747627,14.2283146 L12.6747627,24.7262832 L9.66254383,24.7262832 L9.66254383,14.2283146 Z M11.0918712,12.9152027 L11.0700633,12.9152027 C9.97966732,12.9152027 9.27272727,12.1126905 9.27272727,11.0964388 C9.27272727,10.059407 10.0005666,9.27272727 11.1127705,9.27272727 C12.2240657,9.27272727 12.9073805,10.0574279 12.9291884,11.0934702 C12.9291884,12.1097219 12.2240657,12.9152027 11.0918712,12.9152027 L11.0918712,12.9152027 Z M24.7272727,24.7272727 L21.3116074,24.7272727 L21.3116074,19.2937403 C21.3116074,17.8717796 20.7773133,16.9020361 19.6024117,16.9020361 C18.7037437,16.9020361 18.2039789,17.5561182 17.9713611,18.1884306 C17.8841294,18.4140444 17.8977593,18.7297058 17.8977593,19.0463568 L17.8977593,24.7272727 L14.5138972,24.7272727 C14.5138972,24.7272727 14.557513,15.1030629 14.5138972,14.2283146 L17.8977593,14.2283146 L17.8977593,15.8758891 C18.0976653,15.1555082 19.1789746,14.1273822 20.9045262,14.1273822 C23.045337,14.1273822 24.7272727,15.6384009 24.7272727,18.8890208 L24.7272727,24.7272727 L24.7272727,24.7272727 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoaLinkedin);
export default __webpack_public_path__ + "static/media/boa-linkedin.cf3f07a19a1a670d38dac07eb89a2cd3.svg";
export { ForwardRef as ReactComponent };